import { defineAsyncComponent } from 'vue'
export default {
  "beauty-nail": defineAsyncComponent(() => import("/app/apps/main/layouts/beauty-nail.vue")),
  cabinet: defineAsyncComponent(() => import("/app/apps/main/layouts/cabinet.vue")),
  default: defineAsyncComponent(() => import("/app/apps/main/layouts/default.vue")),
  empty: defineAsyncComponent(() => import("/app/apps/main/layouts/empty.vue")),
  faq: defineAsyncComponent(() => import("/app/apps/main/layouts/faq.vue")),
  landings: defineAsyncComponent(() => import("/app/apps/main/layouts/landings.vue"))
}